module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/assessment_achievements/5@2x_066c6c5fa19b3407649b0a8ddc1eead7.png";